import { Factory } from '../Factory';
import { Service } from '../Service';

namespace app.services.batching {

  export class BatchService extends Service<any> {
    private configService: app.services.IConfigService;
    private httpService: app.services.IHttpWrapperService;

    constructor(resource: angular.resource.IResourceService, rootScope: IRootScope, configService: app.services.IConfigService, resourceWrapperService: app.services.utilities.ResourceWrapperService, httpService: app.services.IHttpWrapperService, private notificationService: app.services.INotificationService) {
      super({resource, rootScope, resourceWrapperService});

      this.configService = configService;
      this.httpService = httpService;

      let raw = this.resource(`${configService.getServerBaseUrlForResource()}/project/:projectId/batch/:id`,
        {id: "@id", projectId: "@projectId"},
        {
          update: {method: "PUT"},
          query: {method: "GET", params: {page: 1, limit: 50}, isArray: false}
        }
      );

      this.itemResource = this.resourceWrapperService.WrapActions(raw);

      this.rootScope.$on("FeedService.BatchingComplete", (event: any, message: any) => {
        this.notificationService.addSuccess({
          title: "Batching Complete",
          description: `Batch: ${message.prefix} has completed.`,
          timeout: 5000
        });
      });

    }

    public Assign(project: any, batch: Batch): ng.IPromise<boolean> {
      return this.httpService.$http({
        method: 'POST',
        url: `${this.configService.getServerBaseUrl()}/project/${project.id}/batch/assign`,
        data: batch
      });
    }

    public GetAll(projectId: string, page: number, limit: number, assignedOnly: boolean = false) {
      return this.itemResource.query({
        projectId: projectId,
        page: page,
        limit: limit,
        assignedOnly
      }).$promise;
    }

  }

  frontendApp.factory("BatchService", ["$resource", "$rootScope", "ConfigService", "ResourceWrapperService", "HttpService", "NotificationService", Factory.Create(BatchService)]);
}
